var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('stars'),_c('header-component',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],class:{'show': !_vm.isLoading}}),_c('mainComponent',{attrs:{"isLoading":_vm.isLoading}}),(!_vm.isLoading)?[_c('first-charter'),_c('second-chapter'),_c('third-chapter'),_c('fourth-chapter'),_c('fifth-chapter')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }